// Copyright (c) Ping. All rights reserved.

import { createContext, useContext } from 'react';

import type { GuidedStep } from './GuidedTourTypes';
import type { TourId } from './tourIds';

export interface GuidedTourContextValue {
  readonly tourId: TourId;
  readonly steps: readonly GuidedStep[];
  // False for manual, on-demand tours (e.g. the per-pane guide) so
  // dismissing them does not stamp a "seen" flag.
  readonly markSeenOnDismiss: boolean;
}

export const GuidedTourContext = createContext<GuidedTourContextValue | null>(null);

/** Read the active tour's id + step list from inside the popover card. */
export function useGuidedTour(): GuidedTourContextValue {
  const value = useContext(GuidedTourContext);
  if (value === null) {
    throw new Error('useGuidedTour must be used inside <GuidedTourHost>');
  }
  return value;
}
